import { defineStore } from 'pinia';
import { io } from 'socket.io-client';
import { EEnv } from '~/types/env';
import { ETriggerId } from '~/types/toasts';
import { useStoreRoot } from '../abstract/root';
import { useStoreToasts } from '../strapi/toasts';
import type { Socket } from 'socket.io-client';

export const useStorePaymentsNotification = defineStore('paymentsNotification', {
  state: () => ({
    socket: null as Socket | null,
  }),
  actions: {
    subscribe(userID: number) {
      if (this.socket && !this.socket.disconnected) {
        return;
      }

      const storeRoot = useStoreRoot();

      let host = window.location.host.replace(/^stage\.|^dev\.|^\d+-dev\./i, '');
      let subDomain = storeRoot.env;

      if (storeRoot.env === 'dev' && host.includes('local')) {
        host = '7bitcasino.com';
        subDomain = EEnv.prod;
      }

      this.socket = io({
        path: `https://${subDomain}-backend.${host}/payments-push`,
        transports: ['websocket'],
        secure: true,
      });

      this.socket.on('connect', () => {
        this.socket?.emit('subscribe', { userID: `_7bit_com_${userID}` });
      });

      this.socket.on('payment', this.onMessage);
    },
    unsubscribe() {
      this.socket?.emit('unsubscribe');
      this.socket?.off('payment', this.onMessage);
    },
    onMessage(data: { error: string; email?: string }, ignoreGTM: boolean = false) {
      const error = data?.error;

      if (error) {
        // @ts-ignore
        useStoreToasts().add(ETriggerId[error], { isGTM: ignoreGTM });
      }
    },
  },
});
